import { render, staticRenderFns } from "./EventLinksTable.vue?vue&type=template&id=4d927d56&scoped=true"
import script from "./EventLinksTable.vue?vue&type=script&lang=ts"
export * from "./EventLinksTable.vue?vue&type=script&lang=ts"
import style0 from "./EventLinksTable.vue?vue&type=style&index=0&id=4d927d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d927d56",
  null
  
)

export default component.exports